import Cookies from 'universal-cookie'

class cookie
{
    constructor(cookie)
    {
        this.cookie = cookie
    }

    set(key, value, options = { path: '/' })
    {
        this.cookie.set(key, value, options)
    }

    get(key)
    {
        return this.cookie.get(key)
    }
}

export default new cookie(new Cookies())
